

///////////////////////////
import React, { useEffect, useContext, useRef, useCallback, useMemo } from "react";
import useMapData from "../hooks/useMapData.jsx";
import MapContext from "../Map/MapContext.js";
import { VectorLayer } from "../Layers";
import { getSelectedStyle, getProjectedVector, getProjectedFromAdindan } from "../Util/Util.js";
//prettier-ignore
import { getParcelColorByOccupancy, getParcelColorByCountry, getParcelColorBySector } from "../Style/ParcelCatgorizationByColor.jsx";
import { occupiedParcelStyle, infraStyle, parkStyle } from "../Style/MapStyle.js";
import { getNonParcelFeatureStyle } from "../Style/NonParcelStyler.jsx";
import { Modify } from "ol/interaction";
import { Vector as VectorSource } from "ol/source";
import LAYER_COLORS from "../Util/LAYER_COLORS";
import { Style, Fill, Stroke, Text } from 'ol/style';

import useDecodedUser from "../../../../../../services/hooks/useDecodedUser";

//prettier-ignore
const CommonLayers = ({ park, blocks, parcels, sheds, otherInfras, greenAreas, buildings, importeds, roads, gcps,
                      wasteDisposals, waters, powers, communications, storages, surveyDatas, plans,zones, unapprovedImports,unapprovedSplitAndMerges,parcelsCategory = null, isEditable = false, highlightParcel = null}) => {
  
  const { map } = useContext(MapContext);
  const { parcelGrouping } = useMapData();
  const decodedUser = useDecodedUser();

  const [countries, sectors, occupancyStatuses] = useMemo(() => {
    const uniqueCountries = new Set();
    const uniqueSectors = new Set();
    const uniqueOccupancyStatuses = new Set();
    
    parcelGrouping?.length && parcelGrouping?.forEach((item) => {
      uniqueCountries.add(item.nationality_origin);
      uniqueSectors.add(item.current_function);
      uniqueOccupancyStatuses.add(item.occupancy_status);
    });

    return [[...uniqueCountries], [...uniqueSectors], [...uniqueOccupancyStatuses]];
  }, [parcelGrouping]);

  const parcelLayerRef = useRef(null);

  // Function to get target UPINs from highlightParcel
  const getTargetUPINs = useCallback(() => {
    
    if (!highlightParcel) {
      console.log('❌ No highlightParcel provided');
      return [];
    }
    
    console.log('🔍 FULL highlightParcel object:', highlightParcel);
    
    const rowData = highlightParcel.rowData || {};
    console.log('📋 FULL rowData:', rowData);
    
    let targetUPINs = [];

    // Look for UPINs in specific column names
    const upin1 = rowData.upin_1 || rowData.UPIN_1 || rowData.upin1;
    const upin2 = rowData.upin_2_to_merge || rowData.UPIN_2_TO_MERGE || rowData.upin2_to_merge || rowData.upin2 ||rowData.upin_1;
    
    console.log('🔍 UPIN 1 found:', upin1);
    console.log('🔍 UPIN 2 TO MERGE found:', upin2);

    // Add UPIN 1 if it exists
    if (upin1) {
      targetUPINs.push(upin1.toString().trim());
    }

    // Add UPIN 2 if it exists
    if (upin2) {
      targetUPINs.push(upin2.toString().trim());
    }

    // If no UPINs found in the specific columns, try other common field names
    if (targetUPINs.length === 0) {
      console.log('🔎 Searching for UPINs in other fields...');
      
      // Check common field names that might contain UPINs
      const possibleUPINFields = [
        'original_upin', 'merged_upins', 'upins', 'parcel_upins', 'target_upins', 
        'parcel_ids', 'original_parcel', 'merged_parcels', 'parcels'
      ];
      
      for (const field of possibleUPINFields) {
        if (rowData[field]) {
          console.log(`📌 Found UPINs in field '${field}':`, rowData[field]);
          if (typeof rowData[field] === 'string') {
            const upinsFromField = rowData[field].split(',').map(upin => upin.trim()).filter(upin => upin);
            targetUPINs = [...targetUPINs, ...upinsFromField];
          } else if (Array.isArray(rowData[field])) {
            const upinsFromField = rowData[field].map(upin => upin.toString().trim()).filter(upin => upin);
            targetUPINs = [...targetUPINs, ...upinsFromField];
          }
        }
      }
    }

    // Remove duplicates and empty values
    targetUPINs = [...new Set(targetUPINs.filter(upin => upin))];

    console.log('🎯 FINAL Target UPINs for highlighting:', targetUPINs);
    console.log('🎯 Row ID being highlighted:', highlightParcel.id);
    
    return targetUPINs;
  }, [highlightParcel]);

  // Function to check if a parcel should be highlighted
  const shouldHighlightParcel = useCallback((featureUPIN, targetUPINs) => {
    if (!featureUPIN || targetUPINs.length === 0) return false;
    
    const normalizedFeatureUPIN = featureUPIN.toString().trim();
    
    // Check exact match
    return targetUPINs.includes(normalizedFeatureUPIN);
  }, []);

  // Function to get the actual UPIN value for display
  const getParcelDisplayName = useCallback((properties, targetUPINs) => {
    const featureUPIN = (properties.upin || properties.id || '').toString().trim();
    
    // Find which target UPIN matches this feature
    const matchingUPIN = targetUPINs.find(upin => upin === featureUPIN);
    
    // Return the actual UPIN value for display
    return matchingUPIN || featureUPIN || 'Parcel';
  }, []);

  // Enhanced getParcelStyle function - HIGHLIGHTS WITH RED BORDER AND ACTUAL UPIN VALUE IN VERY SMALL SIZE
  // const getParcelStyle = useCallback(
  //   (feature) => {
  //     const properties = feature.getProperties();
  //     const featureUPIN = (properties.upin || properties.id || '').toString().trim();
      
  //     // Get the UPINs we want to highlight
  //     const targetUPINs = getTargetUPINs();
      
  //     // Check if this parcel should be highlighted
  //     const shouldHighlight = shouldHighlightParcel(featureUPIN, targetUPINs);
      
  //     if (shouldHighlight) {
  //       console.log('🎯 HIGHLIGHTING PARCEL with red border and UPIN label:', featureUPIN);
        
  //       // Get the base style to extract fill color
  //       let baseStyle;
  //       switch (parcelsCategory) {
  //         case "OCCUP":
  //           baseStyle = getParcelColorByOccupancy(feature, occupancyStatuses);
  //           break;
  //         case "COUNTRY":
  //           baseStyle = getParcelColorByCountry(feature, countries);
  //           break;
  //         case "FUNC":
  //           baseStyle = getParcelColorBySector(feature, sectors);
  //           break;
  //         default:
  //           baseStyle = getParcelColorBySector(feature);
  //       }

  //       // Extract the fill color from the base style
  //       const baseFill = baseStyle.getFill();
  //       const fillColor = baseFill ? baseFill.getColor() : 'rgba(200, 200, 200, 0.4)';
        
  //       // Get the actual UPIN value for display
  //       const displayUPIN = getParcelDisplayName(properties, targetUPINs);
        
  //       // Return style with original fill color + red border + ACTUAL UPIN VALUE in very small size
  //       return new Style({
  //         fill: new Fill({
  //           color: fillColor // Keep the original fill color
  //         }),
  //         stroke: new Stroke({
  //           color: '#FF0000', // Red border for highlighting
  //           width: 3, // Thick border
  //         }),
  //         text: new Text({
  //           text: displayUPIN, // Display ACTUAL UPIN value
  //           //font: 'bold 8px Arial', // VERY SMALL font size (8px) with bold
  //           fill: new Fill({
  //             //color: '#FF0000' // RED text color to match the border
  //           }),
  //         })
  //       });
  //     }
      
  //     // Return the normal style for non-highlighted parcels (no text label)
  //     switch (parcelsCategory) {
  //       case "OCCUP":
  //         return getParcelColorByOccupancy(feature, occupancyStatuses);
  //       case "COUNTRY":
  //         return getParcelColorByCountry(feature, countries);
  //       case "FUNC":
  //         return getParcelColorBySector(feature, sectors);
  //       default:
  //         return getParcelColorBySector(feature);
  //     }
  //   },
  //   [parcelsCategory, occupancyStatuses, countries, sectors, getTargetUPINs, shouldHighlightParcel, getParcelDisplayName],
  // );


  // ##############################
  const getParcelStyle = useCallback(
  (feature) => {
    const properties = feature.getProperties();
    const featureUPIN = (properties.upin || properties.id || '').toString().trim();
    
    // Get the UPINs we want to highlight
    const targetUPINs = getTargetUPINs();
    
    // Check if this parcel should be highlighted
    const shouldHighlight = shouldHighlightParcel(featureUPIN, targetUPINs);
    
    if (shouldHighlight) {
      console.log('🎯 HIGHLIGHTING PARCEL:', featureUPIN);
      
      // Get highlight color from the highlightParcel prop (default to red)
      const highlightColor = highlightParcel?.highlightColor || '#FF0000';
      
      // Get the base style to extract fill color
      let baseStyle;
      switch (parcelsCategory) {
        case "OCCUP":
          baseStyle = getParcelColorByOccupancy(feature, occupancyStatuses);
          break;
        case "COUNTRY":
          baseStyle = getParcelColorByCountry(feature, countries);
          break;
        case "FUNC":
          baseStyle = getParcelColorBySector(feature, sectors);
          break;
        default:
          baseStyle = getParcelColorBySector(feature);
      }

      // Extract the fill color from the base style
      const baseFill = baseStyle.getFill();
      const fillColor = baseFill ? baseFill.getColor() : 'rgba(200, 200, 200, 0.4)';
      
      // For blue color, override the fill completely
      const finalFillColor = highlightColor === 'blue' 
        ? 'rgba(0, 0, 255, 0.6)' // Blue fill with transparency
        : fillColor; // Keep original fill for other colors
      
      // Get the actual UPIN value for display
      const displayUPIN = getParcelDisplayName(properties, targetUPINs);
      
      return new Style({
        fill: new Fill({
          color: finalFillColor
        }),
        stroke: new Stroke({
          color: highlightColor === 'blue' ? '#0000FF' : '#FF0000', // Blue border for blue highlight
          width: 3,
        }),
        text: new Text({
          text: displayUPIN,
          // ... your text styles
        })
      });
    }
    
    // Return normal style for non-highlighted parcels
    switch (parcelsCategory) {
      case "OCCUP":
        return getParcelColorByOccupancy(feature, occupancyStatuses);
      case "COUNTRY":
        return getParcelColorByCountry(feature, countries);
      case "FUNC":
        return getParcelColorBySector(feature, sectors);
      default:
        return getParcelColorBySector(feature);
    }
  },
  [parcelsCategory, occupancyStatuses, countries, sectors, getTargetUPINs, shouldHighlightParcel, getParcelDisplayName, highlightParcel],
);
  // ##############################

  // Force style update when highlightParcel changes
  useEffect(() => {
    if (parcelLayerRef.current) {
      console.log('🔄 Updating parcel styles for highlightParcel:', highlightParcel);
      parcelLayerRef.current.setStyle(getParcelStyle);
      
      // Force a refresh of the layer
      const source = parcelLayerRef.current.getSource();
      if (source) {
        source.changed();
      }
    }
  }, [highlightParcel, getParcelStyle]);

  useEffect(() => {
    if (parcelLayerRef.current) {
      parcelLayerRef.current.setStyle(getParcelStyle);
    }
  }, [parcelsCategory, getParcelStyle]);

  useEffect(() => {
    if (map && isEditable) {
      const vectorLayers = map
        .getLayers()
        .getArray()
        .filter((layer) => layer && layer.getSource() instanceof VectorSource);

      vectorLayers.forEach((layer) => {
        const modifyInteraction = new Modify({
          source: layer.getSource(),
        });
        map.addInteraction(modifyInteraction);
      });

      return () => {
        map
          .getInteractions()
          .getArray()
          .forEach((interaction) => {
            if (interaction instanceof Modify) {
              map.removeInteraction(interaction);
            }
          });
      };
    }
  }, [map, isEditable]);

  return (
    <>
      {park && (
        <VectorLayer title="Park Boundary" source={getProjectedFromAdindan(park)} style={getSelectedStyle(parkStyle, true, "id")}
          zIndex={1}
        />
      )}
       
        {blocks && (
          <VectorLayer
            title="Block"
            source={getProjectedVector(blocks)}
            style={(feature) => {
              return new Style({
                fill: new Fill({ color: LAYER_COLORS.BLOCK.color }),
                stroke: new Stroke({ color: '#000000', width: 2 })
              });
            }}
            zIndex={2}
          />
        )}

      {parcels && (
        <VectorLayer
          ref={parcelLayerRef}
          title="Parcel"
          source={getProjectedVector(parcels)}
          style={getParcelStyle}
          zIndex={4}
        />
      )}
            
    {sheds && (
        <VectorLayer
          title="Sheds"
          source={getProjectedVector(sheds)}
          style={(feature) => {
            // Bypass getNonParcelFeatureStyle completely for testing
            return new Style({
              fill: new Fill({
                color: LAYER_COLORS.SHED.color // #987db7
              }),
              stroke: new Stroke({
                color: '#000000',
                width: 2
              })
            });
          }}
          zIndex={3}
        />
      )}
      
      {buildings && (
        <VectorLayer
          title="Buildings"
          source={getProjectedVector(buildings)}
          style={(feature) => {
            return new Style({
              fill: new Fill({ color: LAYER_COLORS.BUILDING.color }),
              stroke: new Stroke({ color: '#000000', width: 1 })
            });
          }}
          zIndex={6}
        />
      )}

       {/*"PLANS AND OTHER"*/}
      {storages && (
        <VectorLayer
          title="Storages"
          source={getProjectedVector(storages)}
          style={getSelectedStyle(infraStyle, false)}
          zIndex={6}
        />
      )}
       {importeds && (
        <VectorLayer
          title="Imported"
          source={getProjectedVector(importeds)}
          style={getSelectedStyle(infraStyle, false)}
          zIndex={7}
        />
      )}
      {roads && (
        <VectorLayer
          title="Roads"
          source={getProjectedVector(roads)}
          style={(feature) => {
            return new Style({
              fill: new Fill({
                color: LAYER_COLORS.DEFAULT.color // grey
              }),
              stroke: new Stroke({
                color: LAYER_COLORS.ROAD.color, // grey
                width: 3
              })
            });
          }}
          zIndex={15}
        />
      )}

      {otherInfras && (
        <VectorLayer
          title="Other Infrastructures"
          source={getProjectedVector(otherInfras)}
          style={(feature) => {
            return new Style({
              fill: new Fill({
                color: LAYER_COLORS.DEFAULT.color // grey
              }),
              stroke: new Stroke({
                color: LAYER_COLORS.DEFAULT.border, // #888c8f
                width: 1
              })
            });
          }}
          zIndex={15}
        />
      )}

      {surveyDatas && (
        <VectorLayer
          title="Survey Datas"
          source={getProjectedVector(surveyDatas)}
          style={getSelectedStyle(infraStyle, false)}
          zIndex={15}
        />
      )}
      {plans && (
        <VectorLayer
          title="Plans"
          source={getProjectedVector(plans)}
          style={getSelectedStyle(occupiedParcelStyle, false)}
          zIndex={15}
        />
      )}
      {zones && (
        <VectorLayer
          title="Zones"
          source={getProjectedVector(zones)}
          style={getSelectedStyle(occupiedParcelStyle, false)}
          zIndex={15}
        />
      )}
       
      {greenAreas && (
        <VectorLayer
          title="Green Area"
          source={getProjectedVector(greenAreas)}
          style={(feature) => {
            return new Style({
              fill: new Fill({
                color: LAYER_COLORS.GREEN_AREA.color // #6aa84f
              }),
              stroke: new Stroke({
                color: LAYER_COLORS.GREEN_AREA.border, // #274e13
                width: 2
              })
            });
          }}
          zIndex={16}
        />
      )}

      {/*"UTILITIES"*/}

      {waters && (
          <VectorLayer
            title="Waters"
            source={getProjectedVector(waters)}
            style={(feature) => {
              return new Style({
                fill: new Fill({
                  color: LAYER_COLORS.WATER.color // lightblue
                }),
                stroke: new Stroke({
                  color: LAYER_COLORS.WATER.border, // white
                  width: 1
                })
              });
            }}
            zIndex={20}
          />
        )}
        {powers && (
          <VectorLayer
            title="Powers"
            source={getProjectedVector(powers)}
            style={(feature) => {
              return new Style({
                fill: new Fill({
                  color: LAYER_COLORS.POWER.color // red
                }),
                stroke: new Stroke({
                  color: LAYER_COLORS.POWER.border, // black
                  width: 1
                })
              });
            }}
            zIndex={20}
          />
        )}
        {communications && (
          <VectorLayer
            title="Communications"
            source={getProjectedVector(communications)}
            style={(feature) => {
              return new Style({
                fill: new Fill({
                  color: LAYER_COLORS.COMMUNICATION.color // blue
                }),
                stroke: new Stroke({
                  color: LAYER_COLORS.COMMUNICATION.border, // black
                  width: 1
                })
              });
            }}
            zIndex={20}
          />
        )}
        {wasteDisposals && (
          <VectorLayer
            title="Waste Disposal"
            source={getProjectedVector(wasteDisposals)}
            style={(feature) => {
              return new Style({
                fill: new Fill({
                  color: LAYER_COLORS.WASTE.color // brown
                }),
                stroke: new Stroke({
                  color: LAYER_COLORS.WASTE.border, // black
                  width: 1
                })
              });
            }}
            zIndex={20}
          />
        )}

      {gcps && (
        <VectorLayer
          title="GCPS"
          source={getProjectedVector(gcps)}
          style={getSelectedStyle(infraStyle, false)}
          zIndex={20}
        />
      )}
      {
        //NOT YET IMPLEMENTED, to be shown at th etop
      }
      {unapprovedImports && (
        unapprovedImports.map((ui, index) => (
        <VectorLayer
          key={index}
          title="Unapproved Imports"
          source={getProjectedVector(ui)}
          style={(feature)=>getNonParcelFeatureStyle(feature,"red",false,null,null,0.75,"black")}
          zIndex={30}
        />
        ))        
      )}
      {unapprovedSplitAndMerges && (
        unapprovedSplitAndMerges.map((ui, index) => (
        <VectorLayer
          key={index}
          title="Unapproved Split and Merge"
          source={getProjectedVector(ui)}
          style={(feature)=>getNonParcelFeatureStyle(feature,"red",false,null,null,0.75,"black")}
          zIndex={30}
        />
        ))        
      )}
    </>
  );
};

export default CommonLayers;
///////////////
// check